import React, { FC } from "react"
import { StyleSheet, TouchableOpacityProps } from "react-native"
import { spacing } from "../../theme"
import { Text } from "../Text/Text"
import PressableContainer from "./PressableContainer"

interface ComponentProps extends TouchableOpacityProps {
  label: string
}

const PressableLabelAction: FC<ComponentProps> = ({ label, ...props }) => {
  const styles = StyleSheet.flatten([defaultStyles.root, props.style])

  return (
    <PressableContainer {...props} style={styles}>
      <Text preset="bold">{label}</Text>

      {props.children}
    </PressableContainer>
  )
}

// Styles
const defaultStyles = StyleSheet.create({
  root: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: spacing[3],
  },
})

export default PressableLabelAction
